import { memo, useEffect } from 'react'
import { useAppDispatch } from '../../../hooks/useAppDispatch'
import { useAppSelector } from '../../../hooks/useAppSelector'
import { ActionHistoryRow } from '../ActionHistoryRow/ActionHistoryRow'
import styles from './ActionsHistry.module.scss'
import { selectActionsHistoryByGuid } from '../../../store/selectors/actionsSelectors/actionsHistorySelectors'
import { fetchProductActionsHistory } from '../../../store/async-thunks/actions/fetchProductActionsHistory'

interface Props {
    guid: string
    activeActionName: string
}

export const ActionsHistory = memo(function ActionsHistory({
    guid,
    activeActionName,
}: Props) {
    const dispatch = useAppDispatch()
    const actionsHistoryItems = useAppSelector(selectActionsHistoryByGuid(guid))
    const curActionHistoryItems = actionsHistoryItems?.filter(
        (actionHistoryItem) =>
            actionHistoryItem.action_name === activeActionName
    )

    useEffect(() => {
        dispatch(fetchProductActionsHistory({ guid }))
    }, [dispatch, guid])

    return (
        <div>
            <h5>Actions board</h5>
            {!!curActionHistoryItems?.length ? (
                <table className={styles.table}>
                    <thead>
                        <tr>
                            <th className={styles.tableHead}>PRODUCT TIME</th>
                            <th className={styles.tableHead}>ACTION</th>
                            <th className={styles.tableHead}>STATUS</th>
                            <th className={styles.tableHead}>RESULT</th>
                            <th className={styles.tableHead}></th>
                        </tr>
                    </thead>
                    <tbody>
                        {curActionHistoryItems.map((curActionHistoryItem) => (
                            <ActionHistoryRow
                                key={curActionHistoryItem.action_id}
                                actionHistoryItem={curActionHistoryItem}
                            />
                        ))}
                    </tbody>
                </table>
            ) : (
                <div className={`${styles.noData} m-auto`}>No data</div>
            )}
        </div>
    )
})
